import { Pipe, PipeTransform } from '@angular/core';
import { getCurrencySymbol } from '@vendasta/galaxy/utility/currency-utils';

@Pipe({
  name: 'resolveCurrencyCode',

})
/**
 * @param price {string} the numerical price value
 * @param currencyCode {string} Three character code to represent the currency (ISO 4217) ex) USD, CAD, AUS
 * @returns {string} Returns the same currency code string that was input if the price is greater than 0 and the currency code is not USD. Otherwise, returns an empty string.
 */
export class ResolveCurrencyCodePipe implements PipeTransform {
  transform(currencyCode = 'USD', locale?: string): string {
    if (locale) {
      // no-op
    }

    const currencySymbol = getCurrencySymbol(currencyCode);
    // We want to display the currency code if the currency symbol is "$"
    // this is b/c most countries that use the "$" as their currency symbol hold different monetary values and each refer to a different currency code. ex) CAD vs USD
    // in contrast, the currency symbol of the Euro (€) has the same value across all countries that use the "€" symbol b/c they are all refering to the same currency code (EUR).
    if (currencySymbol === '$' && currencyCode !== 'USD') {
      return currencyCode;
    }

    return '';
  }
}
